
import { useFormValues } from './sweepstakes/useFormValues';
import { useEditMode } from './sweepstakes/useEditMode';
import { useFormValidation } from './sweepstakes/useFormValidation';

export const useSweepstakesForm = () => {
  const {
    formValues,
    setFormValues,
    handleInputChange,
    handleTierChange,
    handleRewardChange,
    handleCheckboxChange,
    resetForm
  } = useFormValues();

  const {
    isAddingNew,
    setIsAddingNew,
    editingSweepstakes,
    startEdit,
    resetEditMode
  } = useEditMode(setFormValues);

  const { validateForm } = useFormValidation();

  const completeReset = () => {
    resetForm();
    resetEditMode();
  };

  return {
    isAddingNew,
    setIsAddingNew,
    editingSweepstakes,
    formValues,
    handleInputChange,
    handleTierChange,
    handleRewardChange,
    handleCheckboxChange,
    resetForm: completeReset,
    startEdit,
    validateForm
  };
};
